import React from 'react'
import Section from '../Section'
import Markdown from 'features/Markdown'
import s from './Timeline.scss'
import CmsImg from '../../Utils/CmsImg'
import sText from 'components/Text/Text.scss'
import cn from 'classnames'

export default props => {
  return (
    <Section
      color={props.color}
      fullHeight={props.fullHeight}
      paddingTop={props.paddingTop}
      paddingBottom={props.paddingBottom}
      sectionWidth={props.sectionWidth}
      pattern={props.pattern}
    >
      {props.title && (
        <div
          className={cn(sText.primary, sText.heading2, sText.center)}
          style={{ marginBottom: '30px' }}
        >
          {props.title}
        </div>
      )}
      <div className={s.timeline}>
        <div className={s.marker} />
        {props.items.map(({ fields, sys }) => (
          <div key={sys.id} className={s.timelineRow}>
            <div className={s.timelineItem}>
              <div className={s.arm} />
              <div>
                <div className={cn(sText.heading4, sText.accent)}>{fields.title}</div>
                <Markdown text={fields.text} color={props.color} />
              </div>
              <div className={s.icon}>
                <CmsImg src={fields.icon} />
              </div>
            </div>
          </div>
        ))}
        <div className={s.line} />
        <div className={s.marker} />
      </div>
    </Section>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Timeline/Timeline.jsx